module.exports = __webpack_public_path__ + "static/media/disabled_icon.a4215b68.svg";